import { render } from "./DocDetail.vue?vue&type=template&id=1b9c30be&scoped=true"
import script from "./DocDetail.vue?vue&type=script&lang=ts"
export * from "./DocDetail.vue?vue&type=script&lang=ts"

import "./DocDetail.vue?vue&type=style&index=0&id=1b9c30be&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1b9c30be"

export default script